/**
 * @file ConsentIssuesSummary.tsx
 * @description Сводка ошибок перед публикацией (phase19.16, Р3г;
 * uiux-r3g-consent-texts §5, §6 «Табличка ошибок с переходом к полю»):
 * список полей с ошибкой; нажатие открывает вкладку поля и ставит в него фокус.
 */

import { consentTextFields, type ConsentTextKind } from "@chaiberi/shared";
import { forwardRef } from "react";

import { Button } from "../../ui/button";
import { NoticeStrip } from "../../ui/NoticeStrip";

interface Props {
  kind: ConsentTextKind;
  errors: ReadonlyMap<string, string>;
  onGo: (path: string) => void;
}

export const ConsentIssuesSummary = forwardRef<HTMLDivElement, Props>(function ConsentIssuesSummary({ kind, errors, onGo }, ref) {
  const labels = new Map(consentTextFields(kind).map((f) => [f.path, f.label]));
  return (
    <div ref={ref} tabIndex={-1} className="outline-none">
      <NoticeStrip tone="error" title={`Не опубликовано: исправьте поля (${errors.size})`}>
        <ul className="m-0 flex list-none flex-col p-0">
          {[...errors].map(([path, message]) => (
            <li key={path}>
              <Button variant="link" className="min-h-12 whitespace-normal text-left" onClick={() => onGo(path)}>
                {labels.get(path) ?? path}: {message}
              </Button>
            </li>
          ))}
        </ul>
      </NoticeStrip>
    </div>
  );
});
